import { ProfileV1Data } from './profile-load-v1';
import { recalculateStartLineAngle, calculateLengthTotal } from './profile-utils';

export function profileToStringV1(data: ProfileV1Data): string | null {
    if (!data.lines.length) {
        return null;
    }

    const lines = data.lines.map((line, index) => {
        let alpha = line.alpha;
        let direction = line.direction;
        if (!index) {
            const startLineAngle = recalculateStartLineAngle(line.alpha, line.direction, 0);
            alpha = startLineAngle.angle;
            direction = startLineAngle.direction;
        }

        return [
            1,
            Math.abs(alpha),
            (direction + 1) / 2,
            line.length,
            line.length2,
            0,
            0,
        ].join(';');
    });

    return [
        -1, data.paintSide, -1, 0,
        data.creaseLeft, data.edgeCreaseSizeMM,
        data.creaseRight, data.edgeCreaseSizeMM,
        lines.join('|'),
        calculateLengthTotal(data),
    ].join('%');
}
